import { usePersonalBeautyStore } from "./usePersonalBeautyStore";
export var usePersonalBeautyStoreUserInfo = function usePersonalBeautyStoreUserInfo() {
  var _usePersonalBeautySto = usePersonalBeautyStore(),
    pbsData = _usePersonalBeautySto.pbsData,
    inviteFriendData = _usePersonalBeautySto.inviteFriendData;
  if (pbsData) {
    var _pbsData$beautyStore$, _pbsData$beautyStore;
    var _ref = (_pbsData$beautyStore$ = (_pbsData$beautyStore = pbsData.beautyStore) === null || _pbsData$beautyStore === void 0 ? void 0 : _pbsData$beautyStore.profile) !== null && _pbsData$beautyStore$ !== void 0 ? _pbsData$beautyStore$ : {},
      firstName = _ref.firstName,
      lastName = _ref.lastName,
      photoUrl = _ref.photoUrl;
    return {
      firstName: firstName !== null && firstName !== void 0 ? firstName : null,
      lastName: lastName !== null && lastName !== void 0 ? lastName : null,
      photoUrl: photoUrl !== null && photoUrl !== void 0 ? photoUrl : null
    };
  }
  if (inviteFriendData) {
    var _inviteFriendData$inv;
    var _ref2 = (_inviteFriendData$inv = inviteFriendData.inviteFriendProfile) !== null && _inviteFriendData$inv !== void 0 ? _inviteFriendData$inv : {},
      _firstName = _ref2.firstName,
      _lastName = _ref2.lastName,
      _photoUrl = _ref2.photoUrl;
    return {
      firstName: _firstName !== null && _firstName !== void 0 ? _firstName : null,
      lastName: _lastName !== null && _lastName !== void 0 ? _lastName : null,
      photoUrl: _photoUrl !== null && _photoUrl !== void 0 ? _photoUrl : null
    };
  }
  return {
    firstName: null,
    lastName: null,
    photoUrl: null
  };
};